/* HeyBear · Product "What's inside": theme-editor values by default, with optional product metafields. */
HB.section('product-inside', function (root) {
  var set = function (selector, value) { var node = root.querySelector(selector); if (node && value) node.textContent = value; };
  HB.reveal(root);
  if (root.dataset.contentSource !== 'product_metafields') return;
  return HB.pdp.on(function (key, flavour) {
    var facts = flavour && flavour.facts;
    if (!facts) return;
    set('#insideProtein', facts.protein);
    set('#insideProteinNote', facts.proteinNote);
    set('#insideFibre', facts.fibre);
    set('#insideFibreNote', facts.fibreNote);
    set('#insideSugar', facts.sugar);
    set('#insideSugarNote', facts.sugarNote);
    set('#insideRating', facts.rating ? facts.rating + '★' : '');
    set('#insideRatingNote', facts.ratingNote);
  });
});
